module.exports = __webpack_public_path__ + "static/media/close.2b0a94d9.svg";